<section class="cst_body" *ngIf="(orderDetailsRes | json) != '{}'">
  <div class="container-fluid search_flt_box_main">
    <div class="user_dtl_box">
      <p>
        Order ID :
        <span>{{orderDetailsRes[0].order.patientinfo.order_id}}</span>
      </p>
      <p>
        MRN :
        <span>{{orderDetailsRes[0].order.patientinfo.mrn}}</span>
      </p>
      <p>
        DID :
        <span>{{orderDetailsRes[0].order.order_status.order_did}}</span>
      </p>
      <p>
        Tenant Code :
        <span>{{orderDetailsRes[0].tenantCode}}</span>
      </p>
      <p>
        ORG Code:
        <span>{{orderDetailsRes[0].orgCode}}</span>
      </p>
    </div>
    <div class="customer_dtl_box">
      <div class="row">
        <div class="col">
          <div class="col-12">
            <p>Customer Name</p>
            <span>{{orderDetailsRes[0].order.patientinfo.name}}</span>
          </div>
          <div class="col-12">
            <p>Customer Mobile</p>
            <span>{{orderDetailsRes[0].order.patientinfo.contact}}</span>
          </div>
          <div class="col-12">
            <p>Customer Email</p>
            <span> {{orderDetailsRes[0].order.patientinfo.email}}</span>
          </div>
          <div class="col-12">
            <p>Customer Address</p>
            <span>{{orderDetailsRes[0].order.patientinfo.address}}</span>
          </div>

        </div>
        <div class="col">
          <div class="col-12">
            <p>Service Type</p>
            <span>{{modeOfService}}</span>
          </div>
          <div class="col-12">
            <p>Order Created Date</p>
            <span><span>{{orderDetailsRes[0].order.order_status.created_date | date:'dd/MM/yyyy hh:mm a'
                }}</span></span>
          </div>
          <div class="col-12">
            <p>Scheduled Date</p>
            <span>{{orderDetailsRes[0].order.patientinfo.scheduled_date | date:'dd/MM/yyyy hh:mm a':'UTC' }}</span>
          </div>
          <!--<div class="col-8 selectVendor" *ngIf="orderDetailsRes[0].order.patientinfo.service_type == 2">
            <div *ngIf="!showVendor">
                <p>Choose Vendor
                <select id="inputState" class="form-control col-form-label-sm" [formControl]="vendor" [(ngModel)]="selectValue">
                  <option disabled value="">Select Vendor</option>
                  <option *ngFor="let vendor of vendorList" value={{vendor.userinfo.USER_ID}}>
                    {{vendor.userinfo.USER_NAME}}</option>
                </select><br/>
                <button type="button" class="assign_btn green_btn" (click)="assignVendor()">Assign</button>
              </p>
            </div>
            <div *ngIf="showVendor && orderDetailsRes[0].OStatus != 24" >
              <p>Assigned Vendor</p>
              <span>{{this.orderDetailsRes[0].order.provider_info[0].associate_name}}</span>
            </div>
            <div *ngIf="showVendor && orderDetailsRes[0].OStatus == 24">
              <p>Choose Vendor
              <select id="inputState" class="form-control col-form-label-sm" [formControl]="vendor" [(ngModel)]="selectValue">
                <option disabled value="">Select Vendor</option>
                <option *ngFor="let vendor of vendorList" value={{vendor.userinfo.USER_ID}}>
                  {{vendor.userinfo.USER_NAME}}</option>
              </select><br/>
              <button type="button" class="assign_btn green_btn" (click)="assignVendor()">Re-Assign</button>
            </p>
          </div>
        </div>-->
          
        </div>
        
        <div class="col">
          <div class="col-12">
            <p>Payment Mode</p>
            <span *ngIf="orderDetailsRes[0].payment_info.payable_amount > 0">Pay on delivery</span>
            <span *ngIf="orderDetailsRes[0].payment_info.payable_amount == 0">Prepaid</span>

          </div>
          <div class="col-12">
            <p>Payment Differences &nbsp;</p>
            <span>₹ {{orderDetailsRes[0].payment_info.payable_amount | number:'1.0-2'}}</span>
            <div class="sideBtnsDeck">
            <button type="button" class="upload_btn btn transpBtn"
              (click)="openPaymentLinkModal('paymentLink')"
              *ngIf="isViewPaymentLink && orderDetailsRes[0].payment_info.payable_amount > 0  && orderDetailsRes[0].OStatus != 8" ><img src="assets/icons/send_payment_link.svg"/>Send Payment Link
            </button>
           
            <button type="button" class="upload_btn btn transpBtn" *ngIf="isViewPaymentLink && orderDetailsRes[0].payment_info.payable_amount > 0  && orderDetailsRes[0].OStatus != 8"
            (click)="openPaymentLinkModal('generateReceipt')"><img src="assets/icons/report_status.svg"/>Generate Receipt
           </button>
          </div>
        </div>
          <div class="col-12">
            <p>Order Status</p>
            <span>{{orderDetailsRes[0].data.Nomenclature}}</span>

          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="table_main">
      <div class="row">
        <div class="col-6 flexBox">
          <div class="ord_dtl_card">
            <div class="card_header ">Order Details</div>
            <div class="card_sub_header" *ngFor="let providerInfoObj of orderDetailsRes[0].order.provider_info">

              <div *ngIf="providerInfoObj.component_no == 7">
                <p>Lab branch name & address
                </p>
                <p class="mrg-top">{{providerInfoObj.associate_name}} & {{providerInfoObj.associate_address}},
                  {{providerInfoObj.contact_number}}.</p>

                <div class=" mrg-top row bordBtm">
                  <div class="col-5">
                    <p>Branch Contact Number</p>
                    <label>{{providerInfoObj.branch_contact_number}}</label>
                  </div>
                  <div class="col-5">
                    <p>Branch Email</p>
                    <label>{{providerInfoObj.branch_email}}</label>
                  </div>
                  <div class="col-5">
                    <p>SPOC Name</p>
                    <label>{{providerInfoObj.spoc_name}}</label>
                  </div>
                  <div class="col-5">
                    <p>SPOC Contact Number</p>
                    <label>{{providerInfoObj.spoc_contact}}</label>
                  </div>
                  <div class="col-5">
                    <p>SPOC Email</p>
                    <label>{{providerInfoObj.spoc_email}}</label>
                  </div>


                </div>
                

              </div>
              <div *ngIf="providerInfoObj.component_no == 5">
                <p>Doctor Name
                  <!--<span class="reassign" (click)="openEconsultReassignModal(orderDetailsRes[0])" *ngIf="orderDetailsRes[0].OStatus != 6"><img
                      src="./assets/img/blue_edit.png" > Re-Assign Doctor</span>-->
                </p>
                <p class="mrg-top">{{providerInfoObj.associate_name}}</p>

                <div class=" mrg-top row bordBtm">
                  <div class="col-6">
                    <p>Doctor Contact Number</p>
                    <label *ngIf="providerInfoObj.associate_contact_number">{{providerInfoObj.associate_contact_number}}</label>
                    <!--<label *ngIf="providerInfoObj.contact_number">{{providerInfoObj.contact_number}}</label>-->
                  </div>
                  <div class="col-6">
                    <p>Doctor Email</p>
                    <label *ngIf="providerInfoObj.associate_email_id">{{providerInfoObj.associate_email_id}}</label>
                    <!--<label *ngIf="providerInfoObj.email">{{providerInfoObj.email}}</label>-->
                  </div>
                  <div class="col-6">
                    <p>Doctor Address</p>
                    <label>{{providerInfoObj.associate_address}}</label>
                  </div>
                </div>             
              </div>

              <div *ngIf="providerInfoObj.component_no == 9 && providerInfoObj.associate_name !='' && orderDetailsRes[0].OStatus != 24">
                <p>Vendor Name
                </p>
                <p class="mrg-top">{{providerInfoObj.associate_name}}</p>

                <div class=" mrg-top row bordBtm">
                  <div class="col-6">
                    <p>Vendor Number</p>
                    <label>{{providerInfoObj.associate_contact_number}}</label>
                  </div>
                  <div class="col-6">
                    <p>Vendor Email</p>
                    <label>{{providerInfoObj.associate_email}}</label>
                  </div>
                  <div class="col-6">
                    <p>Vendor Address</p>
                    <label>{{providerInfoObj.associate_address}}</label>
                  </div>
                </div>             
              </div>

            </div>
            <div class="card_body" *ngFor="let orderItemObj of orderDetailsRes[0].order.orderitem">
              <div *ngIf="orderItemObj.item_status != 8">
                <div class="row bordBtm">
                  <div class="col-5">
                    <p>Diagnostics Test Name</p>
                    <label>{{orderItemObj.itemname}}</label>
                  </div>
                  <div class="col-7">
                    <div class="row">
                      <div class="col-6">
                        <p>Initial MRP</p>
                        <label>₹ {{orderItemObj.gross_amount}}</label>
                      </div>
                      <div class="col-6">
                        <p>Uploaded MRP &nbsp;
                        </p>
                        <label>₹ {{orderItemObj.net_amount}}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row bordBtm">
                  
                  <!--<div class="col-5" *ngIf="orderItemObj.roleBasedService !=1">
                    <p>Prescription &nbsp; <img class="presripImg" src="./assets/img/share-square-solid-blue.png"
                        (click)="openPrescriptionUploadReportModal(orderDetailsRes[0])"></p>
                    <div *ngIf="orderItemObj.roleBasedService !=1"><label class="fntRegular">Prescription Pending
                        Reports</label></div>

                  </div>-->

                </div>
              </div>
            </div>
          </div>
          <!-- <div class="report_upload_card">
            <div class="card_header ">Remarks</div>
            <div class="card_body">
              <form [formGroup]="remarks_Form">
                <div class="row bordBtm">
                  <div class="col-10 flexBox">
                    <textarea type="area" class="form-control col-form-label-sm"  rows="4" cols="50" formControlName="remarks">
                    </textarea>
                  </div>
                  <div class="col-2 flexBox">
                    <button type="submit" class="btn info_btn"  (click)="remarksSubmit()" [disabled]="(remarks_Form.invalid)">Submit</button>
                  </div>
                </div>
              </form>
          
            </div>
            <div class="mrg-tp-15 spaceDiv" *ngIf=" orderDetailsRes[0]?.remarks != undefined && orderDetailsRes[0]?.remarks != null && orderDetailsRes[0]?.remarks?.length > 0">
              <table class="table table-striped uploadedRecordTable">
                <thead>
                  <tr>
                    <th scope="col">S No</th>
                    <th scope="col">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let remarks of orderDetailsRes[0]?.remarks;let i=index ">
                    <td>
                        {{i+1}}
                      </td>
                    <td style="text-align: left;">
                      {{remarks?.remarks}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> -->
        </div>
        <div class="col-6 flexBox">
          <div class="payment_dtl_card">
            <div class="card_header">Payment Details</div>
            <div class="card_body">
              <p>
                <label>Gross Amount</label>
                <span>₹{{orderDetailsRes[0].payment_info.gross_amount | number:'1.0-2'}}</span>
              </p>
              <p *ngIf="orderDetailsRes[0].payment_info.discount_amount != undefined && orderDetailsRes[0].payment_info.discount_amount !=0">
                <label>Discount Amount</label>
                <span>₹{{orderDetailsRes[0].payment_info.discount_amount | number:'1.0-2'}}</span>
              </p>

              <p class="bdr_top" >
                <label>Net Amount</label>
                <span>₹{{orderDetailsRes[0].payment_info.net_amount | number:'1.0-2'}}</span>
              </p>
              <p class="bdr_top" *ngIf="orderDetailsRes[0].payment_info.voucher_amount != undefined && orderDetailsRes[0].payment_info.voucher_amount !=0">
                <label>Voucher Amount</label>
                <span>₹{{orderDetailsRes[0].payment_info.voucher_amount | number:'1.0-2'}}</span>
              </p>
              <p *ngIf="orderDetailsRes[0].payment_info.wallet_amount != undefined && orderDetailsRes[0].payment_info.wallet_amount !=0">
                <label>Wallet Amount</label>
                <span>₹{{orderDetailsRes[0].payment_info.wallet_amount | number:'1.0-2'}}</span>
              </p>
              <p class="bdr_top" *ngIf="orderDetailsRes[0].payment_info.paid_amount != undefined && orderDetailsRes[0].payment_info.paid_amount !=0">
                <label>Prepaid Amount</label>
                <span>₹{{orderDetailsRes[0].payment_info.paid_amount | number:'1.0-2'}}</span>
              </p>
              <p class="bdr_top" >
                <label>Total Paid Amount</label>
                <span>₹{{orderDetailsRes[0].payment_info.paid_amount | number:'1.0-2'}}</span>
              </p>
              <p class="bdr_top">
                <label>Payable Amount</label>
                <span>₹{{orderDetailsRes[0].payment_info.payable_amount | number:'1.0-2'}}</span>
              </p>
              <p class="bdr_top" *ngIf="orderDetailsRes[0].payment_info.refund_amount != undefined && orderDetailsRes[0].payment_info.refund_amount !=0">
                <label>Refund Amount</label>
                <span>₹{{orderDetailsRes[0].payment_info.refund_amount | number:'1.0-2'}}</span>
              </p>

            </div>
          </div>
          <!--<div class="report_upload_card"
            *ngIf="isViewReport && roleBasedValue !=1 && (orderDetailsRes[0].OStatus == 301 || orderDetailsRes[0].OStatus == 302 || orderDetailsRes[0].OStatus == 303 || orderDetailsRes[0].OStatus == 6)">
            <div class="card_header">Upload Reports</div>
            <div class="col-12">
              <div *ngIf="orderDetailsRes[0].OStatus == 301 || orderDetailsRes[0].OStatus == 302 || orderDetailsRes[0].OStatus == 6">

              <form [formGroup]="uploadForm" (ngSubmit)="onSubmit(orderDetailsRes[0]._id)">
                <div class="flexBetween spaceDiv">
                  <div class="col-md-3">
                    <select class="form-control col-form-label-sm" [(ngModel)]="documentType"
                      formControlName="documentType">
                      <option value="null" disabled>Select Document Type</option>
                      <option value="Prescription">Prescription</option>
                      <option value="labreport">Lab Report</option>
                      <option value="imagingreport">Imaging Report</option>
                      <option value="dischargeSummary">Discharge Summary</option>
                    </select>
                  </div>
                  <div class="col-md-5">
                    <input type="file" name="profile" (change)="onFileSelect($event)" />
                  </div>
                  <div class="col-md-2">
                    <button type="submit" class="btn info_btn">Attach</button>
                  </div>
                </div>
              </form>
              </div>  
              <div>

              </div>
              <div class="mrg-tp-15 spaceDiv" *ngIf="getdocuments != null && getdocuments !=undefined && getdocuments.length > 0">
                <table class="table table-striped uploadedRecordTable">
                  <thead>
                    <tr>
                      <th scope="col">Uploaded Records</th>
                      <th scope="col">Uploaded On</th><th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let document of getdocuments">
                      <td *ngIf="document.documentType=='imagingreport' || document.documentType=='labreport'  || document.documentType=='Prescription'  || document.documentType=='dischargeSummary'">
                        {{document.documentName}}</td>
                      <td *ngIf="document.documentType=='imagingreport' || document.documentType=='labreport'  || document.documentType=='Prescription'  || document.documentType=='dischargeSummary'">
                        {{document.uploadedOn | date:'dd/MM/yyyy hh:mm a'}}</td>
                      <td class="view_btn" *ngIf="document.documentType=='imagingreport' || document.documentType=='labreport'  || document.documentType=='Prescription'  || document.documentType=='dischargeSummary'">
                          <img class="exitImg" src="./assets/img/download.png" (click)="download(document.documentId)"
                                      [disabled]="fileDownloadDisable"  ngbTooltip="Download">&nbsp; 
                          <img class="exitImg" src="./assets/img/delete.png"
                            (click)="delete(document.documentId,document.documentName,orderDetailsRes[0]._id)"  ngbTooltip="Delete"/>
                       </td>  
                    </tr>
                  </tbody>
                </table>
              </div>
                <button type="button" class="upload_btn green_btn upload-finish-btn"
                  (click)="changeOrderStatus(orderDetailsRes[0]._id,orderDetailsRes[0].order.documents)"
                  *ngIf="orderDetailsRes[0].OStatus == 301 || orderDetailsRes[0].OStatus == 302">
                  Mark Upload Reports
                </button>
            </div>

           
          </div>-->
          <div class="report_upload_card"
            *ngIf="orderDetailsRes[0].order.patientinfo.service_type != '1' && (orderDetailsRes[0].order.patientinfo.service_type == '3' || orderDetailsRes[0].order.patientinfo.service_type == '4') && orderDetailsRes[0].OStatus != 8">
            <div class="card_header">Upload Reports</div>
            <div class="col-12">
              <form [formGroup]="uploadForm" (ngSubmit)="onSubmit(orderDetailsRes[0]._id)">
                <div class="flexBetween spaceDiv">
                  <div class="col-md-2" *ngIf="isReportInput">
                    <input type="checkbox" name="finalReport" formControlName="finalReport"/>
                    <label>final report</label>
                  </div>
                  <div class="col-md-3">
                     <input type="text" class="form-control col-form-label-sm" formControlName="documentType" readonly >
                  </div>
                  <div class="col-md-5">
                    <input type="file" name="profile" (change)="onFileSelect($event)" />
                  </div>
                  <div class="col-md-2">
                    <button type="submit" class="btn info_btn">Attach</button>
                  </div>
                </div>
              </form> 
              <div>

              </div>
              <div class="mrg-tp-15 spaceDiv" *ngIf="getdocuments != null && getdocuments !=undefined && getdocuments.length > 0">
                <table class="table table-striped uploadedRecordTable">
                  <thead>
                    <tr>
                      <th scope="col">Uploaded Records</th>
                      <th scope="col">Uploaded On</th><th scope="col">IsFinal Report</th><th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let document of getdocuments">
                      <td *ngIf="document.documentType=='imagingreport' || document.documentType=='labreport'  || document.documentType=='Prescription'  || document.documentType=='dischargeSummary' ||  document.documentType=='Assessment' ">
                        {{document.documentName}}</td>
                      <td *ngIf="document.documentType=='imagingreport' || document.documentType=='labreport'  || document.documentType=='Prescription'  || document.documentType=='dischargeSummary' ||  document.documentType=='Assessment' ">
                        {{document.uploadedOn | date:'dd/MM/yyyy hh:mm a'}}</td>
                      <td *ngIf="document?.finalReport != 1">No</td>
                      <td *ngIf="document.finalReport == 1">yes</td>
                      <td class="view_btn" *ngIf="document.documentType=='imagingreport' || document.documentType=='labreport'  || document.documentType=='Prescription'  || document.documentType=='dischargeSummary' ||  document.documentType=='Assessment'">
                          <img class="exitImg" src="./assets/img/download.png" (click)="download(document.documentId)"
                                      [disabled]="fileDownloadDisable"  ngbTooltip="Download">&nbsp; 
                          <img class="exitImg" src="./assets/img/delete.png"
                            (click)="delete(document.documentId,document.documentName,orderDetailsRes[0]._id)"  ngbTooltip="Delete" *ngIf="document.finalReport != 1"/>
                          <img class="exitImg" src="./assets/img/share-square-solid-blue.png"
                            (click)="resendReport(document.documentId,document.documentName,orderDetailsRes[0]._id)"  ngbTooltip="Resend" *ngIf="document.finalReport == 1"/>
                       </td>
                    </tr>
                  </tbody>
                </table>
              </div>
                <button type="button" class="upload_btn green_btn upload-finish-btn"
                  (click)="changeOrderStatus(orderDetailsRes[0]._id,orderDetailsRes[0].order.documents)"
                  *ngIf="(orderDetailsRes[0].order.patientinfo.service_type == '3' || orderDetailsRes[0].order.patientinfo.service_type == '4') && (orderDetailsRes[0].mode_of_service == '2'  && orderDetailsRes[0].tenantCode == '1000177')" >
                  Mark Upload Reports
                </button>
            </div>           
          </div>
          <div class="report_upload_card"
            *ngIf=" (orderDetailsRes[0].order.patientinfo.service_type == '5' || orderDetailsRes[0].order.patientinfo.service_type == '6' || orderDetailsRes[0].order.patientinfo.service_type == '7' || orderDetailsRes[0].order.patientinfo.service_type == '8'|| orderDetailsRes[0].order.patientinfo.service_type == '100') ">
            <div class="card_header">Upload Reports</div>
            <div class="col-12">
              <form [formGroup]="uploadForm" (ngSubmit)="onSubmit(orderDetailsRes[0]._id)">
                <div class="flexBetween spaceDiv">
                  <!-- <div class="col-md-2" *ngIf="isReportInput">
                    <input type="checkbox" name="finalReport" formControlName="finalReport"/>
                    <label>final report</label>
                  </div> -->
                  <div class="col-md-5">
                     <select type="text" class="form-control col-form-label-sm" formControlName="documentType"  >
                      <option value="">Select Reports Type</option>
                      <option value="Prescription">Prescription</option>
                      <option value="labreport">Lab Report</option>
                      <option value="imagingreport">Radiology Report</option>
                      <option value="dischargeSummary">Discharge Summary</option>
                      <option value="Payment">Payment</option>

                     </select>
                  </div>
                  <div class="col-md-5">
                    <input type="file" name="profile"  formControlName="uploadDoc" (change)="onFileSelect($event)"  />
                  </div>
                  <div class="col-md-2">
                    <button type="submit" class="btn info_btn" [disabled]="!(!uploadForm.invalid &&  uploadFile != null && uploadFile !='')">Attach</button>
                  </div>
                </div>
              </form> 
              <div>

              </div>
              
              <div class="mrg-tp-15 spaceDiv" *ngIf="getdocuments != null && getdocuments !=undefined && getdocuments.length > 0">
                <table class="table table-striped uploadedRecordTable">
                  <thead>
                    <tr>
                      <th scope="col">Uploaded Records</th>
                      <th scope="col">Uploaded On</th>
                      <th scope="col">IsFinal Report</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let document of getdocuments">
                      <td *ngIf="document.documentType=='imagingreport' || document.documentType=='labreport'  || document.documentType=='Prescription'  || document.documentType=='dischargeSummary' || document.documentType=='Payment' ||  document.documentType=='Assessment' ">
                        {{document.documentName}}</td>
                      <td *ngIf="document.documentType=='imagingreport' || document.documentType=='labreport'  || document.documentType=='Prescription'  || document.documentType=='dischargeSummary' || document.documentType=='Payment' ||  document.documentType=='Assessment' ">
                        {{document.uploadedOn | date:'dd/MM/yyyy hh:mm a'}}</td>
                      <td *ngIf="document?.finalReport != 1">No</td>
                      <td *ngIf="document.finalReport == 1">yes</td>
                      <td class="view_btn" *ngIf="document.documentType=='imagingreport' || document.documentType=='labreport'  || document.documentType=='Prescription'  || document.documentType=='dischargeSummary' || document.documentType=='Payment' ||  document.documentType=='Assessment' ">
                          <img class="exitImg" src="./assets/img/download.png" (click)="download(document.documentId)"
                                      [disabled]="fileDownloadDisable"  ngbTooltip="Download">&nbsp; 
                          <img class="exitImg" src="./assets/img/delete.png"
                            (click)="delete(document.documentId,document.documentName,orderDetailsRes[0]._id)"  ngbTooltip="Delete" *ngIf="document.finalReport != 1"/>
                          <img class="exitImg" src="./assets/img/share-square-solid-blue.png"
                            (click)="resendReport(document.documentId,document.documentName,orderDetailsRes[0]._id)"  ngbTooltip="Resend" *ngIf="document.finalReport == 1"/>
                       </td>
                    </tr>
                  </tbody>
                </table>
              </div>
                <button type="button" class="upload_btn green_btn upload-finish-btn"
                  (click)="changeOrderStatus(orderDetailsRes[0]._id,orderDetailsRes[0].order.documents)"
                  *ngIf="(orderDetailsRes[0].order.patientinfo.service_type == '3' || orderDetailsRes[0].order.patientinfo.service_type == '4') && orderDetailsRes[0].mode_of_service == '2'">
                  Mark Upload Reports
                </button>
            </div>           
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mrg-lr-no">
    <div class="col-md-12">
      <div class="pull-right">
        <button type="button" class="btn transpBtnMany" *ngIf="orderDetailsRes[0].order.patientinfo.service_type == '6' && (orderDetailsRes[0].order?.business?.assmtCmpl == undefined || orderDetailsRes[0].order?.business?.assmtCmpl !=1 ) "
          (click)="assessmentForm('FRM_NRS_ASMT')"><img src="assets/icons/reorder.svg"/>Nursing Assessment</button>
          <button type="button" class="btn transpBtnMany" *ngIf="orderDetailsRes[0].order.patientinfo.service_type == '100' && (orderDetailsRes[0].order?.business?.assmtCmpl == undefined || orderDetailsRes[0].order?.business?.assmtCmpl !=1 ) "
          (click)="assessmentForm('FRM_PRE_ASMT')"><img src="assets/icons/reorder.svg" />Pre Assessment</button>
          <button type="button" class="btn transpBtnMany" *ngIf="orderDetailsRes[0].order.patientinfo.service_type == '7' && (orderDetailsRes[0].order?.business?.assmtCmpl == undefined || orderDetailsRes[0].order?.business?.assmtCmpl !=1 ) "
          (click)="assessmentForm('FRM_PHY_ASMT')"><img src="assets/icons/reorder.svg"/>Physio Assessment</button>
          <button type="button" class="btn transpBtnMany"
          (click)="openReAllocateModal('re-allocate')" *ngIf="isReallocation"><img src="assets/icons/reorder.svg"/>Re-allocate</button>
          <button type="button" class="btn transpBtnMany"
          (click)="openReAllocateModal('allocate')" *ngIf="isTobeassigned"><img src="assets/icons/reorder.svg"/>Allocate</button>  
          <!--1 <button type="button" class="btn green_btn"
          (click)="openReAllocateModal('reports')" *ngIf="isReports && this.orderDetailsRes[0].order.patientinfo.order_status != '6'">Complete</button>  -->
        <button type="button" class="btn transpBtnMany" (click)="openReScheduleItemModal(orderDetailsRes[0],1)" *ngIf="(orderDetailsRes[0].OStatus < 3 ||orderDetailsRes[0].OStatus == 17) && (orderDetailsRes[0].order.patientinfo.service_type != '5' && orderDetailsRes[0].order.patientinfo.service_type != '6' && orderDetailsRes[0].order.patientinfo.service_type != '7' && orderDetailsRes[0].order.patientinfo.service_type != '8')"><img src="assets/icons/reorder.svg"/>Reschedule Order</button>
        <button type="button" class="btn transpBtnMany" (click)="openReScheduleItemModal(orderDetailsRes[0],'forceReschedule')" *ngIf="(orderDetailsRes[0].OStatus < 3 ||orderDetailsRes[0].OStatus == 17) && (orderDetailsRes[0].order.patientinfo.service_type == '5' || orderDetailsRes[0].order.patientinfo.service_type == '6' || orderDetailsRes[0].order.patientinfo.service_type == '7' || orderDetailsRes[0].order.patientinfo.service_type == '8')"><img src="assets/icons/reorder.svg"/>Reschedule Order</button>
        <span *ngIf="orderDetailsRes[0].order.patientinfo.service_type == '3' && orderDetailsRes[0].mode_of_service == '1'">

        <!--<button type="button" class="btn info_btn" (click)="openReScheduleItemModal(orderDetailsRes[0],16)" *ngIf="orderDetailsRes[0].OStatus == 2">Request For ReSchedule</button>-->

        <!--<button type="button" class="btn orange_btn" (click)="openReScheduleItemModal(orderDetailsRes[0],15)" *ngIf="orderDetailsRes[0].OStatus == 2">Request For Cancelled</button>-->

          <button type="button" class="btn transpBtnMany"
          (click)="openReAllocateModal('allocate')" *ngIf="orderDetailsRes[0].OStatus == 0"><img src="assets/icons/reorder.svg"/>Allocate</button> 

        <button type="button" class="btn transpBtnMany"
          (click)="openReAllocateModal('re-allocate')" *ngIf="orderDetailsRes[0].OStatus == 1"><img src="assets/icons/reorder.svg"/>Re-allocate</button>

        <button type="button" class="btn transpBtnMany" (click)="openConfirmModal(orderDetailsRes[0].order.patientinfo.order_id,3,'accept')" *ngIf="orderDetailsRes[0].OStatus == 1"><img src="assets/icons/reorder.svg"/>Accept Order</button>

        <button type="button" class="btn transpBtnMany" (click)="openConfirmModal(orderDetailsRes[0].order.patientinfo.order_id,3,'way')" *ngIf="orderDetailsRes[0].OStatus == 2"><img src="assets/icons/reorder.svg"/>On the Way</button>

         <button type="button" class="btn transpBtnMany" (click)="openConfirmModal(orderDetailsRes[0].order.patientinfo.order_id,3,'reached')" *ngIf="orderDetailsRes[0].OStatus == 3"><img src="assets/icons/reorder.svg"/>Reached</button>

        <button type="button" class="btn transpBtnMany" (click)="openConfirmModal(orderDetailsRes[0].order.patientinfo.order_id,3,'sample')" *ngIf="orderDetailsRes[0].OStatus == 4"><img src="assets/icons/reorder.svg"/>Sample Collected</button>

          <button type="button" class="btnt transpBtnMany" (click)="openConfirmModal(orderDetailsRes[0].order.patientinfo.order_id,3,'sample_phelp')" *ngIf="orderDetailsRes[0].OStatus == 5"><img src="assets/icons/reorder.svg"/>Sample Submit To PHELP</button>

        <button type="button" class="btn transpBtnMany"
          (click)="openCollectSampleModal('samplecollection',orderDetailsRes[0].order.patientinfo.order_id,orderDetailsRes[0]?.odid,orderDetailsRes[0]?.order?.patientinfo?.barcode?.barcode[0] || '')" *ngIf="orderDetailsRes[0].OStatus == 101"><img src="assets/icons/reorder.svg"/>Collect Samples</button>

        <button type="button" class="btn transpBtnMany" (click)="openSubmitSampleModal('samplesubmit',orderDetailsRes[0].order.patientinfo.order_id)" *ngIf="orderDetailsRes[0].OStatus == 102"><img src="assets/icons/reorder.svg"/>Submit Samples To Lab</button>
<!-- 
         <button type="button" class="btn green_btn" (click)="openConfirmModal(orderDetailsRes[0].order.patientinfo.order_id,3,'complete')" *ngIf="orderDetailsRes[0].OStatus != 15 && orderDetailsRes[0].OStatus != 8 && orderDetailsRes[0].OStatus != 6">Mark Order as Completed</button> -->

    </span>
          <button type="button" class="btn transpBtnMany"
          (click)="openCollectSampleModal('samplecollection',orderDetailsRes[0].order.patientinfo.order_id,this.orderDetailsRes[0].odid,this.orderDetailsRes[0].order.patientinfo.barcode.barcode[0])" *ngIf="isCollectsample"><img src="assets/icons/reorder.svg"/>Collect Samples</button> 
          <button type="button" class="btn transpBtnMany"
          (click)="openSubmitSampleModal('samplesubmit',orderDetailsRes[0].order.patientinfo.order_id)" *ngIf="isSubmitSample"><img src="assets/icons/reorder.svg"/>Submit Samples</button> 
           <!--<button type="button" class="btn orange_btn" *ngIf="this.orderDetailsRes[0].order.patientinfo.order_status != '6' && this.orderDetailsRes[0].order.patientinfo.order_status != '8'" (click)="openOrderCancelPopup(2,orderDetailsRes[0])">Order Cancel</button>-->
          <!--3 <button type="button" class="btn green_btn" *ngIf="orderDetailsRes[0].OStatus == '6'" [disabled]="fileDownloadDisable">Order Completed</button>-->
          <span *ngIf="orderDetailsRes[0].order.patientinfo.service_type == '5' || orderDetailsRes[0].order.patientinfo.service_type == '6' || orderDetailsRes[0].order.patientinfo.service_type == '7' || orderDetailsRes[0].order.patientinfo.service_type == '57' || orderDetailsRes[0].order.patientinfo.service_type == '8' && orderDetailsRes[0].mode_of_service == '1'">
      <!-- <span> -->
        <!-- <button type="button" class="btn transpBtnMany"
        (click)="openReAllocateModal('createOfficer')"><img src="assets/icons/allocate.svg"/>Create Officer</button>  -->
        <button type="button" class="btn transpBtnMany"
        (click)="openReAllocateModal('forceAllocate')" *ngIf="orderDetailsRes[0].OStatus == 0"><img src="assets/icons/allocate.svg"/>Allocate</button>    
        <button type="button" class="btn transpBtnMany" (click)="openConfirmModal(orderDetailsRes[0].order.patientinfo.order_id,3,'complete')" *ngIf="orderDetailsRes[0].OStatus != 15 && orderDetailsRes[0].OStatus != 8 && orderDetailsRes[0].OStatus != 6"><img src="assets/icons/mark-ord-completed.svg"/>Mark Order as Completed</button>
        <button type="button" class="btn transpBtnMany" *ngIf=" orderDetailsRes[0].OStatus != 8 && orderDetailsRes[0].OStatus != 6" (click)="openReScheduleItemModal(orderDetailsRes[0],8)"><img src="assets/icons/cancel.svg"/>Cancel Order</button>  
      </span>
      <span *ngIf="orderDetailsRes[0].order.patientinfo.service_type == '19' ">
        <button type="button" class="btn transpBtnMany"
          (click)="openConfirmModal(orderDetailsRes[0].order.patientinfo.order_id,3,'complete')"
          *ngIf="orderDetailsRes[0].OStatus != 15 && orderDetailsRes[0].OStatus != 8 && orderDetailsRes[0].OStatus != 6"><img
            src="assets/icons/mark-ord-completed.svg" />Mark Order as Completed</button>
      </span>
          <button type="button" class="btn transpBtnMany" (click)="openReScheduleItemModal(orderDetailsRes[0],15)" *ngIf="this.orderDetailsRes[0].order.patientinfo.order_status != '6' && this.orderDetailsRes[0].order.patientinfo.order_status != '8' && this.orderDetailsRes[0].order.patientinfo.order_status != '106' && this.orderDetailsRes[0].order.patientinfo.order_status != '15'"><img src="assets/icons/req-cancel.svg"/>Request For Cancellation</button>    
      <button type="button" class="btn transpBtnMany"
        (click)="openConfirmModal(orderDetailsRes[0].order.patientinfo.order_id,3,'complete')"
        *ngIf="orderDetailsRes[0].OStatus != 15 && orderDetailsRes[0].OStatus != 8 && orderDetailsRes[0].OStatus != 6 && orderDetailsRes[0].tenantCode == '1000273' && orderDetailsRes[0].orgCode =='100372'"><img
          src="assets/icons/mark-ord-completed.svg" />Mark Order as Completed</button>
          <button type="button" class="btn transpBtnMany"
          (click)="openConfirmModal(orderDetailsRes[0].order.patientinfo.order_id,3,'complete')"
          *ngIf="orderDetailsRes[0].order.patientinfo.service_type == '2' && orderDetailsRes[0].OStatus != 15 && orderDetailsRes[0].OStatus != 8 && orderDetailsRes[0].OStatus != 6 && orderDetailsRes[0].tenantCode == '1000239' && orderDetailsRes[0].orgCode =='100326'"><img
            src="assets/icons/mark-ord-completed.svg" />Mark Order as Completed</button>

      </div>
      <div class="pull-left">
        <button type="button" class="btn closeGreenBordBtn" (click)="CloseTab()">Close</button>
      </div>
    </div>
  </div>

</section>

<!--Payment Differences Modal-->
<ng-template #paymentDifferenceModal let-modal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Modal title</p>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body customModalBody">
    <p>One fine body&hellip;</p>
  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
  </div>
</ng-template>
<!--Payment Difference Modal-->

<!--Re-Assign Diagnostic Center Modal Section End -->

<ng-template #paymentDifferenceModalreassign let-modal>
  <div class="modal-header customBlueHeader" *ngIf="isAddItem">
    <p class="modal-title">Add Test</p>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body customModalBody">
    <div class="form-group">
      <label>Diagnostics Centre Name</label>
      <select class="form-control col-form-label-sm">
        <option>Select</option>
        <option>...</option>
      </select>
    </div>

    <div class="form-group">
      <label>Test Name</label>
      <select class="form-control col-form-label-sm">
        <option>Select</option>
        <option>...</option>
      </select>
    </div>

    <div class="form-group">
      <label>Test Price</label>
      <input type="text" class="form-control col-form-label-sm" placeholder="2,500">
    </div>

    <div class="form-group">
      <label>Scheduled Date & Time</label>
      <input type="text" class="form-control col-form-label-sm" placeholder="DD/MM/YYYY">
    </div>

    <div class="form-group">
      <label>Comments</label>
      <textarea class="form-control col-form-label-sm"></textarea>
    </div>

  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn green_btn" (click)="modal.close('Close click')">Re Assign</button>
  </div>
</ng-template>
<!--Re-Assign Diagnostic Center Modal Section End -->

<!--Add Tests Modal Section Start -->

<ng-template #paymentDifferenceModaladd let-modal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Add Test22</p>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body customModalBody">
    <div class="form-group">
      <label>Diagnostics Centre Name</label>
      <input type="text" class="form-control col-form-label-sm" placeholder="Diagnostics Centre Name">
    </div>

    <div class="form-group">
      <label>Test Name</label>
      <select class="form-control col-form-label-sm">
        <option>Select</option>
        <option>...</option>
      </select>
    </div>

    <div class="form-group">
      <label>Test Price</label>
      <input type="text" class="form-control col-form-label-sm" placeholder="2,500">
    </div>

    <div class="form-group">
      <label>Comments</label>
      <textarea class="form-control col-form-label-sm"></textarea>
    </div>

  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn green_btn" (click)="modal.close('Close click')">Add</button>
  </div>
</ng-template>

<!--Add Tests Modal Section End -->

<!-- Re-Schedule Modal Section Start -->

<ng-template #paymentDifferenceModalreschedule let-modal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Re-Schedule</p>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ng-container *ngIf="!isConfirmedOrder">
    <div class="modal-body customModalBody">
      <div class="form-group">
        <label>Schedule Date & Time</label>
        <div class="input-group">
          <input class="form-control" (dateSelect)="getDate($event)" placeholder="yyyy-mm-dd"
            value="{{curDate | date:'yyyy-mm-dd'}}" name="dp" ngbDatepicker #fD="ngbDatepicker">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="fD.toggle()" type="button"><i
                class="fa fa-calendar" aria-hidden="true"></i></button>
          </div>
        </div>

        <br />
        <select id="timeDropDown" [(ngModel)]="slotTimingInfo" class="form-control col-form-label-sm">
          <option selected>--Select--</option>
          <option [ngValue]="slotRes" *ngFor="let slotRes of slotResponse">
            {{slotRes.from_time}} - {{slotRes.to_time}}
          </option>
        </select>

      </div>
      <div class="modal-footer customModalFooter">
        <button type="button" class="btn green_btn" (click)="submitModalData()">Confirm</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isConfirmedOrder">
    {{confirmOrderResponse}}
  </ng-container>

</ng-template>

<!-- Re-Schedule Modal Section End -->


<!-- Prescription Upload Modal Section Start -->

<ng-template #paymentDifferenceModalprescription let-modal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Add Test</p>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body customModalBody">

    <p>Dear Customer please upload your Prescription through this link.</p>

    <a href="#">www.prescriptionhere.com/upload</a>

  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn green_btn" (click)="modal.close('Close click')">Send</button>
  </div>
</ng-template>

<!-- Priscreption UPload Modal Section End -->

<!-- Prescription Upload Modal Section Start -->

<ng-template #resendOtp let-modal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Resend Otp</p>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ng-container *ngIf="!isOtpSend">
    <div class="modal-body customModalBody">

      <p>otp will receive to Your registered mobile number:</p>

      <!-- <a href="#">www.diagnosticsorder.com/payments</a>  -->

    </div>
    <div class="modal-footer customModalFooter">
      <button type="button" class="btn green_btn" (click)="sendOtp()">Send</button>
    </div>
  </ng-container>
  <!-- <div class="modal-footer customModalFooter">
    <button type="button" class="btn green_btn" (click)="sendOtp()">Send</button>
  </div> -->
  <ng-container *ngIf="isOtpSend">
    {{otpResponse}}
    <div class="modal-footer customModalFooter">
      <button type="button" class="btn green_btn" (click)="modal.close('Close click')">Close</button>


    </div>
  </ng-container>

</ng-template>

<!-- Priscreption UPload Modal Section End -->

<!--Prescription Upload Modal-->
<ng-template #prescriptionUploadModal let-modal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Prescription Upload</p>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ng-container *ngIf="!isPrescriptionSend">
    <div class="modal-body customModalBody">
      <p class="marB15">Dear Customer please do pay difference amount through this link.</p>

      <a href="#">www.prescriptionuploadhere.com/payments</a>
    </div>
    <div class="modal-footer customModalFooter">

      <button type="button" class="btn btn-light" (click)="sendPrescriptionUrl()">Send</button>
    </div>
  </ng-container>
  <ng-container *ngIf="isPrescriptionSend">
    {{prescriptionResponse}}

    <div class="modal-footer customModalFooter">
      <button type="button" class="btn green_btn" (click)="modal.close('Close click')">Close</button>


    </div>
  </ng-container>
</ng-template>
<!--Prescription Modal-->

<ng-template #paymentDifferences let-modal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Payment Differences

    </p>
    <button type="button" class="close" aria-label="Close" (click)="closePopup()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ng-container *ngIf="!isPaymentDifferences">
    <div class="modal-body customModalBody">
      <p>Dear Customer please do pay difference amount through this link.</p>
    </div>
    <div class="modal-footer customModalFooter">
      <button type="button" class="btn green_btn"
        (click)="paymentDiff(orderDetailsRes[0].order.patientinfo.order_id)">Send</button>
    </div>

  </ng-container>
  <ng-container *ngIf="isPaymentDifferences">
    {{paymentDiffResponse}}
    <div class="modal-footer customModalFooter">
      <button type="button" class="btn green_btn" (click)="closePopup()">Close</button>


    </div>
  </ng-container>
</ng-template>

<!--Delete Test Modal-->
<ng-template #deleteTestModal let-modal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Delete Test</p>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body customModalBody">
    <p>Are you sure, you want to delete this test?</p>

  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn green_btn" (click)="modal.close('Close click')">Cancel</button>

    <button type="button" class="btn btn-light" (click)="deleteItem()">Delete</button>


  </div>
</ng-template>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">Please Wait. </p>
</ngx-spinner>

<!--Delete Test Modal-->